import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, Paper } from '@mui/material';
import { closeAllModals, closeModal } from 'reducers/modalReducer';
import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';

export const CoverageDomicileApprovalModal = ({ brUid }: { brUid: string }) => {
  const dispatch = useDispatch();
  const runtimeConfig = useRuntimeConfig();

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    async function handleMessage(event: MessageEvent) {
      const message = event.data.message;
      if (message === ClmPortalIncomingPostMessageTypes.CLOSE_MODAL) {
        dispatch(closeModal('CoverageDomicileApprovalModal'));
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Dialog
      id="coverage-domicile-modal"
      data-testid="coverage-domicile-modal"
      open={true}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dialog-title"
      onClose={() => dispatch(closeAllModals())}
      PaperProps={{ style: { height: '80%' } }}
      PaperComponent={Paper}
    >
      <EmbeddedIFrame
        id="coverage-domicile-model-iframe"
        title="KYC"
        url={`${runtimeConfig.configData.iframeUrls.brCoreIframe}/business-relationship/${brUid}/coverage-domicile-approval`}
        centered
        height="100%"
      />
    </Dialog>
  );
};
